module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/investments-332b91641ec419002f86e29dbd726669.svg";